export type AdminOtpDeliveryChannel = "email" | "sms";

export function normalizeAdminOtpDeliveryChannel(
  value?: string | null
): AdminOtpDeliveryChannel {
  return value === "sms" ? "sms" : "email";
}

export interface IAdminOtpChallengeResponse {
  otpRequired: boolean;
  challengeId?: string;
  expiresInSeconds?: number;
  completionToken?: string;
  deliveryChannel?: AdminOtpDeliveryChannel;
}

export interface IAdminOtpVerifyResponse {
  valid: boolean;
  completionToken?: string;
}
